import { TermsResource, termsResource } from '@witkac/kartamiejska-resources';
import { ProfileType, TermType, Terms } from '@witkac/kartamiejska-shared';

import { AbstractModule } from './abstract.module';

export class TermsModule extends AbstractModule<TermsResource> {
  public state = {
    current: []
  };

  public actions = {
    getCurrent: (context: any, { profileType, type }: { profileType: ProfileType; type: TermType }) => {
      return this.resource.termsCurrent(profileType, undefined, type).then(terms => {
        context.commit('saveCurrent', terms);
        return terms;
      });
    }
  };

  public mutations = {
    saveCurrent: (localState: any, terms: Terms[]) => (localState.current = terms)
  };
}

export default new TermsModule(termsResource);
